export enum LottoSort {
    utc = 'utcDate',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/lotto/_private/enums.ts